import React, { Component } from "react";
import { Link } from 'react-router-dom';
import Aspects from "../DeckBuilderComponents/Aspects";

class UserFavoritesGridRows extends Component {

  render() {

  var faves = this.props.favorites;
    return (
      faves.map(function(favorite, i){
        return (
          <tr>
            <td><Link to={"/DBV2/DeckView/" + favorite.deckId}>{favorite.deckName}</Link></td>
            <td>{favorite.author}</td>
            <td><Aspects deckAspects={favorite.aspects} /></td>
          </tr>
        )
      })
    );
  }
}

export default UserFavoritesGridRows;



// WEBPACK FOOTER //
// ./src/Authentication/UserFavoritesGridRows.js